<template>
    <footer class="footer-container">
        <p class="copyright-text">Copyright © {{year}} Superintendence of Cultural Heritage ® All Rights Reserved.</p>

        <div class="engineered-by-arkafort">
            <p>Engineered by</p>
            <img src="../assets/Arkafort-logo.svg" alt="Arkafort"/>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        computed: {
            year() {
                let date = new Date().getFullYear();
                return date;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer-container {
        @apply flex flex-col bg-secondary w-full py-4;
        grid-area: footer;

        @screen md {
            @apply flex flex-row items-center justify-between;
        }

        .copyright-text {
            @apply pb-4 mb-4 border-b-2 border-primary text-white text-xxs text-center mx-2;

            @screen md {
                @apply pb-0 mb-0 border-b-0 pr-8 mr-8 border-r-2 border-primary text-xs ml-auto;
            }

            @screen lg {
                @apply text-sm;
            }
        }

        .engineered-by-arkafort {
            @apply flex flex-row mx-auto;

            @screen md {
                @apply ml-0;
            }

            & > p {
                @apply text-xs text-white;

                @screen lg {
                    @apply text-sm;
                }
            }

            & > img {
                @apply ml-4 h-4;
            }
        }
    }
</style>